// components/Stage.jsx
function Stage() {
    return (
        <div className="w-full bg-neutral-800 text-center py-4 mb-8 rounded-lg">
            STAGE
        </div>
    );
}

export default Stage;